import React from 'react'
import BaseSelectPanel from './BaseSelectPanel'
import AreaSelectModal from '@pc/components/Works/Panel/selectModal/AreaSelectModal'
import StationSelectModal from '@pc/components/Works/Panel/selectModal/StationSelectModal'

import EmphasisHeading from '@pc/components/Works/Panel/shared/heading/EmphasisHeading'
import ConditionParagraph from '@pc/components/Works/Panel/shared/ConditionParagraph'
import ButtonGroup from '@pc/components/Works/Panel/shared/button/ButtonGroup'

import buildConditionWords from '@pc/components/Works/Panel/util/buildConditionWords'
import type { SearchParamsAttributes, ConditionReducer } from '@pc/components/Works/Panel/type'

interface PropsType {
  params: SearchParamsAttributes
  conditionReducer: ConditionReducer
}

const AreaSelectPanel = (props: PropsType) => {
  const { params, conditionReducer } = props

  const el = document.querySelector<HTMLElement>('.js-works-search-panel')
  const prefectureAttr = el?.dataset.worksPrefecture
  const prefecture = prefectureAttr === undefined ? undefined : JSON.parse(prefectureAttr).data

  const currentConditions = () => {
    const areaTitles = [
      conditionReducer.attributes.condition_title_maps.city_ids,
      conditionReducer.attributes.condition_title_maps.line_ids,
      conditionReducer.attributes.condition_title_maps.station_ids
    ]
      .flat()
      .filter((v): v is string => v != null)

    return <ConditionParagraph>{buildConditionWords(areaTitles)}</ConditionParagraph>
  }

  return (
    <BaseSelectPanel>
      <EmphasisHeading>エリア・駅</EmphasisHeading>
      {currentConditions()}
      <ButtonGroup>
        <AreaSelectModal params={params} prefecture={prefecture} />
        <StationSelectModal params={params} prefecture={prefecture} />
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default AreaSelectPanel
